<template>
    <b-modal v-model="showModal" title="Filter By Your Custom Fields" size="sm">
        <div>
            <p>Select the field you want to use, then the values you want to filter by.</p>
        </div>

        <CustomDataFilter
            ref="customDataFilter"
            :init-filters="filters"
            :custom-fields-list="customFieldsList"
            :for-search="forSearch"
            @updateCustomDataFilter="updateFilter"
        />

        <template #modal-footer>
            <b-button variant="primary" size="lg" @click="apply">Apply</b-button>
        </template>
    </b-modal>
</template>

<script>

import CustomDataFilter from "@/components/customFields/CustomDataFilter.vue";
import customFieldsService from "@/services/custom-fields.service";

export default {
    props: {
        prefix: {
            type: String,
            default: '',
        },

        forSearch: {
            type: Boolean,
            default: false,
        },

        customOptions: {
            type: Object,
            default() {
                return null
            } ,
        },

        initFilters: {
            type: Array,
            default() {
                return []
            },
        },
    },

    components: {
        CustomDataFilter,
    },

    data() {
        return {
            filters: [],
            customFieldsList: {},
            showModal: false,
        };
    },

    watch: {
        initFilters: {
            handler: function (val) {
                this.filters = this.arrayHelper.cloneArray(val);
            },
            deep: true,
            immediate: true,
        }
    },

    mounted() {
        if (this.customOptions) {
            this.customFieldsList = this.customOptions;
        } else {
            customFieldsService.getFields("company_diligence", 1).then(response => {
                this.customFieldsList = response.data
            });
        }
    },

    methods: {
        open() {
            this.showModal = true;
        },

        updateFilter(filters) {
            this.filters = filters;
        },

        apply() {
            this.$emit('updateCustomDataFilter', this.arrayHelper.cloneArray(this.filters));
            this.showModal = false;
        },

        removeFilter(index) {
            this.filters.splice(index, 1);
        },

        removeFilterById(id) {
            let index = this.filters.findIndex(item => parseInt(item.id) === parseInt(id));

            if (index >= 0) {
                this.filters.splice(index, 1);
            }
        },

        clearFilters() {
            this.filters = [];
        }
    }
}
</script>

<style scoped>

</style>
